module.exports = __webpack_public_path__ + "img/add.a548f6d2.svg";